import axios from "axios";
import {
  appendAuthInterceptor,
  requestWrapper,
} from "../../../../Common/serviceFactory";
import presitentStore from "../../../../store";
import { reportingAsSelector } from "../../../../store/applicantsSlice";

const { store } = presitentStore;

const axiosApplicantsInstance = axios.create({
  baseURL: `${process.env.REACT_APP_REQUEST_APPLICANTS}`,
});

const axiosProgramInstance = axios.create({
  baseURL: `${process.env.REACT_APP_REQUEST_PROGRAM}/program`,
});

const appendAsHeader = async (config) => {
  const reportingAs = reportingAsSelector(store.getState());
  if (!!reportingAs) config.headers["X-REPORTING-AS"] = reportingAs;
  return config;
};

const axiosCMSInstance = axios.create({
  baseURL: process.env.REACT_APP_CMS_REQUEST_BASE_URL,
});
axiosApplicantsInstance.interceptors.request.use(appendAsHeader);
appendAuthInterceptor(axiosApplicantsInstance);
appendAuthInterceptor(axiosProgramInstance);

export async function createProposalPDF({ proposalId, header }) {
  return await requestWrapper(
    axiosApplicantsInstance.get(`/proposal/${proposalId}/GeneratePDF`, {
      params: {
        idType: "ProposalId",
        header: header || "",
      },
    })
  );
}
export async function registerReferee(request) {
  return await requestWrapper(
    axiosCMSInstance.post(`api/account/referee/register`, request)
  );
}
export async function getSubmitStatus(props) {
  const { proposalId } = props;
  return await requestWrapper(
    axiosApplicantsInstance.get(`/proposal/${proposalId}/checksubmit`)
  );
}

export async function getGeneralInfoProgress(props) {
  const { proposalId, applicantId } = props;
  if (!applicantId || !proposalId) return;

  return await requestWrapper(
    axiosApplicantsInstance.get(
      `/proposal/${proposalId}/checksubmit/generalInformation/${applicantId}`
    )
  );
}
export async function getFinancingProgress(props) {
  const { proposalId, applicantId } = props;
  if (!applicantId || !proposalId) return;

  return await requestWrapper(
    axiosApplicantsInstance.get(
      `/proposal/${proposalId}/checksubmit/financing/${applicantId}`
    )
  );
}
export async function getSchedulesProgress(props) {
  const { proposalId, applicantId } = props;
  if (!applicantId || !proposalId) return;

  return await requestWrapper(
    axiosApplicantsInstance.get(
      `/proposal/${proposalId}/checksubmit/schedules/${applicantId}`
    )
  );
}
export async function getMiscellaneousProgress(props) {
  const { proposalId } = props;
  if (!proposalId) return;

  return await requestWrapper(
    axiosApplicantsInstance.get(
      `/proposal/${proposalId}/checksubmit/miscellaneous`
    )
  );
}

export async function getApplicantSubmitStatus(props) {
  const { proposalId } = props;
  return await requestWrapper(
    axiosApplicantsInstance.get(`/applicant/${proposalId}/checksubmit`)
  );
}
export async function getDaysLeft() {
  return await requestWrapper(
    axiosApplicantsInstance.get(`/proposal/daysleft`)
  );
}
export async function getProposalData(proposalId) {
  if (Boolean(proposalId)) {
    return await requestWrapper(
      axiosApplicantsInstance.get(`/proposal/get/${proposalId}`)
    );
  }
  return await requestWrapper(
    axiosApplicantsInstance.get(`/applicant/proposal`)
  );
}
export async function getApplicant() {
  return await requestWrapper(axiosApplicantsInstance.get(`/applicant/get`));
}
export async function getContactRishum() {
  return await requestWrapper(
    axiosApplicantsInstance.get(`/applicant/contact`)
  );
}
export async function GetApplicantAcademicBackground() {
  return await requestWrapper(
    axiosApplicantsInstance.get(`/applicant/academicbackground`)
  );
}
export async function GetApplicantPreviousEmployment() {
  return await requestWrapper(
    axiosApplicantsInstance.get(`/applicant/previousemployment`)
  );
}
export async function getFunding(props) {
  const { fundingId } = props;
  return await requestWrapper(
    axiosApplicantsInstance.get(`/parallelfunding/${fundingId}/get`)
  );
}
export async function getApplicantProjectTimeSchedule(props) {
  return await requestWrapper(
    axiosApplicantsInstance.get(`/applicant/projectschedule`)
  );
}
export async function getProposalProjectTimeSchedule(props) {
  const { proposalId } = props;
  return await requestWrapper(
    axiosApplicantsInstance.get(`/proposal/${proposalId}/projectschedule`)
  );
}
export async function getColleagues({ proposalId }) {
  const propsosalApplicants = await getProposalsApplicants({ proposalId });
  const colleagues = propsosalApplicants.applicantsDetails.map((ad) => ({
    email: ad.emailadress,
    name: ad.applicant.name,
    id: ad.applicant.id,
    isntitutionId: ad.applicant.institutionId,
    institutionName: ad.applicant.institutionName,
    pici: ad.applicant.pici,
  }));
  return colleagues;
}
export async function getProposalsApplicants(props) {
  const { proposalId } = props;
  return await requestWrapper(
    axiosApplicantsInstance.get(`/proposal/${proposalId}/applicants`)
  );
}

export async function getResearchAreas() {
  return await requestWrapper(axiosApplicantsInstance.get(`/utility/areas`));
}
export async function getResearchSubAreas(props) {
  const { areaId } = props;
  return await requestWrapper(
    axiosApplicantsInstance.get(`/utility/subareas/${areaId}`)
  );
}
export async function getBudgetClauses() {
  return await requestWrapper(axiosApplicantsInstance.get(`/budget/get`));
}
export async function getBudgetClausesByProposalId(props) {
  const { proposalId } = props;
  return await requestWrapper(
    axiosApplicantsInstance.get(`/proposal/${proposalId}/budgetclauses`)
  );
}
export async function getProgramInfoByProgramId(props) {
  const { programType, infoField } = props;
  return await requestWrapper(
    axiosProgramInstance.get(`/${programType}/info/${infoField}`)
  );
}
export async function getProposalRefereesByProposalId(props) {
  const { proposalId } = props;
  return await requestWrapper(
    axiosApplicantsInstance.get(`/proposal/${proposalId}/proposalreferees`)
  );
}
export async function GetBioethicalApprovals(props) {
  const { proposalId } = props;
  return await requestWrapper(
    axiosApplicantsInstance.get(`/proposal/${proposalId}/approvals`)
  );
}
export async function GetContactByProposalRefereeId(props) {
  const { ProposalRefereeId } = props;
  return await requestWrapper(
    axiosApplicantsInstance.get(
      `/proposal/${ProposalRefereeId}/proposalreferees/contact`
    )
  );
}
export async function updateProposal(props) {
  const { proposal } = props;
  return await requestWrapper(
    axiosApplicantsInstance.post(`/proposal/update`, proposal)
  );
}
export async function UpdateBioethicalApprovals(props) {
  const { proposalId, approval } = props;
  const approvals = approval.approved;
  return await requestWrapper(
    axiosApplicantsInstance.post(
      `/proposal/${proposalId}/approvals/update`,
      approvals
    )
  );
}
export async function deactivateProposal(props) {
  const { proposalId } = props;
  return await requestWrapper(
    axiosApplicantsInstance.post(`/proposal/deactivate`, proposalId)
  );
}
export async function submitProposal(props) {
  const { proposalId } = props;
  const submitStatus = 100000003; //SubmittedByApplicationLeader
  return await requestWrapper(
    axiosApplicantsInstance.post(
      `/proposal/${proposalId}/updatestatus/${submitStatus}`
    )
  );
}
export async function updateFunding(props) {
  const { funding } = props;
  return await requestWrapper(
    axiosApplicantsInstance.post(`/parallelfunding/update`, funding)
  );
}
export async function updateProposalRefreeByContact(props) {
  const { proposalRefereeId, contact } = props;
  return await requestWrapper(
    axiosApplicantsInstance.post(
      `/proposal/proposalreferee/${proposalRefereeId}/update`,
      contact
    )
  );
}
export async function udateProjectSchedule(props) {
  const { projectsSchedules } = props;
  return await requestWrapper(
    axiosApplicantsInstance.post(
      `/applicant/projectschedule/update`,
      projectsSchedules
    )
  );
}
export async function updateApplicantMajorresearchinterest(props) {
  const { majorresearchinterest } = props;
  return await requestWrapper(
    axiosApplicantsInstance.post(
      `/applicant/update/majorresearchinterest`,
      JSON.stringify(majorresearchinterest),
      { headers: { "Content-Type": "application/json" } }
    )
  );
}
export async function updateApplicantAcademicBackground(props) {
  const { academicBackground } = props;
  return await requestWrapper(
    axiosApplicantsInstance.post(
      `/applicant/academicbackground/update`,
      academicBackground
    )
  );
}
export async function createApplicantAcademicBackground(props) {
  const { academicBackground } = props;
  return await requestWrapper(
    axiosApplicantsInstance.post(
      `/applicant/academicbackground/create`,
      academicBackground
    )
  );
}
export async function createProjectSchedule(props) {
  const { projectsSchedules, applicantId } = props;
  return await requestWrapper(
    axiosApplicantsInstance.post(
      `/applicant/${applicantId}/projectschedule/create`,
      projectsSchedules
    )
  );
}
export async function createBudgetClause(props) {
  const { budgetClause } = props;
  return await requestWrapper(
    axiosApplicantsInstance.post(`/budget/budgetClause/create`, budgetClause)
  );
}
export async function createApplicantPreviousEmployment(props) {
  const { previousEmployment } = props;
  return await requestWrapper(
    axiosApplicantsInstance.post(
      `/applicant/previousemployment/create`,
      previousEmployment
    )
  );
}
export async function createProposalRefreeByContact(props) {
  const { proposalId, contact, recommendedBy } = props;
  return await requestWrapper(
    axiosApplicantsInstance.post(
      `/proposal/proposalreferee/${proposalId}/${recommendedBy}/create`,
      contact
    )
  );
}
export async function updateApplicantPreviousEmployment(props) {
  const { previousEmployment } = props;
  return await requestWrapper(
    axiosApplicantsInstance.post(
      `/applicant/previousemployment/update`,
      previousEmployment
    )
  );
}
export async function updateBudgetClause(props) {
  const { budgetClause } = props;
  return await requestWrapper(
    axiosApplicantsInstance.post(`/budget/budgetClause/update`, budgetClause)
  );
}
export async function updateApplicant(props) {
  const { applicantData } = props;
  return await requestWrapper(
    axiosApplicantsInstance.post(`/applicant/update/contact`, applicantData)
  );
}
export async function DeactivateAcademicBackground(props) {
  const { academicBackgroundId } = props;
  return await requestWrapper(
    axiosApplicantsInstance.post(
      `/applicant/${academicBackgroundId}/academicbackground/deactivate`
    )
  );
}
export async function DeactivatePreviousEmployment(props) {
  const { previousEmploymentsId } = props;
  return await requestWrapper(
    axiosApplicantsInstance.post(
      `/applicant/previousemployment/${previousEmploymentsId}/deactivate`
    )
  );
}
export async function DeactivateProjectTimeSchedule(props) {
  const { projectsSchedulesId } = props;
  return await requestWrapper(
    axiosApplicantsInstance.post(
      `/applicant/${projectsSchedulesId}/projectschedule/deactivate`
    )
  );
}
export async function DeactiveBudgetClause(props) {
  const { budgetClauseId } = props;
  return await requestWrapper(
    axiosApplicantsInstance.post(
      `/budget/budgetClause/${budgetClauseId}/deactivate`
    )
  );
}
export async function DeactiveProposalRefferee(props) {
  const { proposalRefereeId } = props;
  return await requestWrapper(
    axiosApplicantsInstance.post(
      `/proposal/proposalreferee/${proposalRefereeId}/deactivate`
    )
  );
}
